import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  page: {
    width: "100%",
    backgroundColor: "#edf4fa",
  },
  container: {
    width: "100%",
    boxSizing: "border-box",
    // clear the fixed app header
    padding: "120px 24px 64px",
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1.1fr)",
    gap: "48px",
    alignItems: "start",
    maxWidth: "1180px",
    margin: "0 auto",
    [theme.breakpoints.down("md")]: {
      gridTemplateColumns: "minmax(0, 1fr)",
      maxWidth: "640px",
      gap: "24px",
      padding: "96px 16px 40px",
    },
  },
  imageContainer: {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    position: "sticky",
    top: "100px",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  picture: {
    width: "100%",
    height: "auto",
    display: "block",
  },
  formCard: {
    width: "100%",
    minWidth: 0,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    padding: "40px",
    boxShadow: "0 10px 30px rgba(15, 23, 42, 0.08)",
    backgroundColor: "white",
    borderRadius: "16px",
    [theme.breakpoints.down("sm")]: {
      padding: "24px 18px",
      borderRadius: "14px",
    },
  },
  logo: {
    width: "140px",
    height: "auto",
    marginBottom: "16px",
    [theme.breakpoints.down("sm")]: {
      width: "110px",
      alignSelf: "center",
    },
  },
  heading: {
    fontFamily: "Inter",
    fontSize: "34px",
    fontWeight: 700,
    lineHeight: 1.15,
    margin: "0 0 24px",
    color: "#111",
    wordBreak: "break-word",
    [theme.breakpoints.down("sm")]: {
      fontSize: "26px",
      margin: "0 0 18px",
    },
  },
  role: {
    display: "block",
    color: theme.palette.primary.main,
  },
  tagline: {
    display: "block",
    marginTop: "12px",
    fontFamily: "Inter",
    fontSize: "17px",
    fontWeight: 400,
    lineHeight: 1.45,
    color: "#374151",
    [theme.breakpoints.down("sm")]: {
      fontSize: "15px",
    },
  },
  form: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  contactContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "24px",
    boxSizing: "border-box",
  },
  contactHeading: {
    fontFamily: "Inter",
    fontSize: "28px",
    fontWeight: 700,
    lineHeight: 1.2,
    color: "#111",
    margin: "0 0 12px",
  },
  contactText: {
    fontFamily: "Inter",
    fontSize: "14px",
    lineHeight: 1.5,
    color: "#374151",
    margin: 0,
  },
  contactEmail: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    wordBreak: "break-all",
  },
}));

export default useStyles;
